// extracted by mini-css-extract-plugin
export default {"container__icon":"icon_container__icon__qmDLE"};